module.exports = __webpack_public_path__ + "img/ImGletscher2.af784dcc.svg";